module.exports = __webpack_public_path__ + "files/dd0e292cdf281bb43b8122a530f43e9d.png";